<template>
  <div>
    <div class="SecendCardStyle" v-for="(item, index) in list" :key="index">
      <router-link
        :to="`/unit/${item.id}/${slugGenerator(item.title)}`"
        class="card_link"
      >
        <div class="contenCard" data-aos="fade-in">
          <img class="cardImg" :src="item.image" :alt="item.title" />
          <div class="cardbox">
            <div class="topCardBox">
              <p>{{ item.title }}</p>

              <img class="logo" :src="item.logo" :alt="item.title" />
            </div>

            <div class="cardText">
              <p>{{ item.short_description }}</p>
              <!-- <p v-if="item.addresses.length>0" class="location">
              <LocationIcon class="locationicon" />
              {{item.addresses[0].address}}
            </p> -->
            </div>
            <!-- 
          <div v-if="item.addresses.length>0"  class="cardPhoneNumber">
            <span> {{ item.addresses[0].phones }}  <TelIcon/> </span>
          </div> -->
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import CardImg from "../../assets/images/factory2.jpg";
import cardLogo from "../../assets/images/Kaleh_logo.png";
import LocationIcon from "../svgs/LocationIcon.vue";
import TelIcon from "../svgs/TelIcon.vue";

export default {
  data() {
    return {
      cardContent: {
        cardImg: CardImg,
        cardTitle: "کارخانه لبنیات کاله",
        cardLogo: cardLogo,
        cardDesc:
          " اگر شما یک طراح هستین و یا با طراحی های گرافیکی سروکار دارید به متن های برخورده اید که با نام لورم ایپسوم شناخته می‌شوند. لورم ایپسوم یا طرح‌نما (به انگلیسی: Lorem ipsum) متنی ساختگی و بدون معنی است که برای امتحان فونت و یا پر کردن فضا در یک طراحی گرافیکی و یا صنعت چاپ استفاده میشود. طراحان وب و گرافیک از این متن برای پرکردن صفحه و ارائه شکل کلی طرح استفاده می‌کنند. ",
        cardLocation:
          "تهران، خیابان جمهوری، خیابان ۱۲ فروردین نبش تقاطع خیابان آذربایجان، پلاک ۱۳۶",
        cardPhoneNumber: "۰۲۱-۶۶۴۵۴۵۱۱ - ۰۲۱-۶۶۴۵۴۵۱۱"
      }
    };
  },
  methods: {
     slugGenerator(name) {
      if (name == null) return name;
      let result = " ";
      result = name.replace(/ /g, "-");
      return result;
    }
    },
  props: {
    list: Array
  },
  components: { LocationIcon, TelIcon }
};
</script>

<style>
.SecendCardStyle {
  display: grid;
  grid-template-columns: 1fr;
  background-color: #fff;
  border-radius: 10px;
  margin: 1rem 0;
}

.contenCard {
  display: flex;
  justify-content: flex-start;
}

.cardbox {
  width: 100%;
  padding: 1rem;
}

.topCardBox {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.topCardBox img {
  width: 100px;
}
.topCardBox p {
  font-weight: bold;
  color:black;
}
.cardImg {
  width: 300px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  object-fit: cover;
}

.cardText {
  margin: 1rem 0;
  text-align: justify;
}

.cardText p {
  font-size: 14px;
  color:black;
}

.location {
  display: flex;
  align-items: center;
  padding: 1rem 0;
  color: #0d6fed;
}

.locationicon {
  margin: 0;
}

.locationicon path {
  fill: #0d6fed;
}

.cardPhoneNumber {
  display: flex;
  justify-content: flex-end;
}
.cardPhoneNumber span {
  display: flex;
  align-items: center;
}
</style>
